import { DASHBOARD_ENDPOINTS } from '@/consts/api'
import { useDashboardApiClient } from '../useDashboardApiClient'

export const postWorkspaceSecret = (params: {
    workspaceId: string
}) => {
    return useDashboardApiClient<{ secret: string }>({
        url: DASHBOARD_ENDPOINTS.SECRET,
        urlParams: params,
        method: 'POST',
    })
}
